import { Trans, useTranslation } from "react-i18next";
import ImageWithFallback from "../../../shared/imageWithFallback";
import ScreenHeader from "../../components/ScreenHeader";
import { dateLabel, timeLabel } from "./dates";
import "./orderDetails.scss";

const CalendarIcon = () => (
  <svg className="od-v2-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 9H21" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3V6M16 3V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const PinIcon = () => (
  <svg className="od-v2-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21C12 21 19 15.5 19 10A7 7 0 1 0 5 10C5 15.5 12 21 12 21Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

// V2 order details (sub-view of /orderHistory) — presentational. The cancel flow
// (dialog + API) stays in the V1 screens/orderHistory.jsx, reached via onCancel.
function OrderDetails({ order, isPast, isOrthodox, defaultImg, imgFallbackSrc, onCancel, onBack }) {
  const { t } = useTranslation();

  const canCancel = !isPast && Boolean(order.IsCancelAllow);
  const orderNumber = order.ID ?? order.RecordID; // field unverified on history items — line hides when absent
  const imgSrc = isPast ? order.MobClubLogoPath : order.ClubLogo;

  return (
    <div className={`od-v2${canCancel ? " od-v2--with-cta" : ""}`}>
      <ScreenHeader title={t("ORDER_DETAILS_TITLE")} onBack={onBack} />

      <section className="od-v2-order-card">
        {/* Image first in DOM = rightmost in RTL, per design */}
        <div className="od-v2-order-img">
          <ImageWithFallback src={isOrthodox ? defaultImg : imgSrc} fallbackSrc={imgFallbackSrc} alt="Club" />
        </div>
        <div className="od-v2-order-info">
          {order.LessonName ? (
            <>
              <p className="od-v2-club">{order.ClubName}</p>
              <p className="od-v2-activity">{order.LessonName}</p>
            </>
          ) : (
            <p className="od-v2-activity">{order.ClubName}</p>
          )}
          <p className="od-v2-meta">
            <CalendarIcon />
            {dateLabel(order.SupplyDate)} {timeLabel(order.SupplyDate)}
          </p>
          {order.Address && (
            <p className="od-v2-meta">
              <PinIcon />
              {order.Address}
            </p>
          )}
          {orderNumber != null && <p className="od-v2-order-number">{t("ORDER_NUMBER", { number: orderNumber })}</p>}
        </div>
      </section>

      <div className="od-v2-divider" />

      {canCancel ? (
        <>
          {order.CancellationTime > 0 && (
            <p className="od-v2-cancel-window">{t("CANCELLATION_TIME_INFO", { hours: order.CancellationTime })}</p>
          )}
          <div className="od-v2-bottom-bar">
            <button type="button" className="od-v2-cancel-cta" onClick={() => onCancel(order)}>
              {t("CANCEL_ORDER_CTA")}
            </button>
          </div>
        </>
      ) : !isPast ? (
        <div className="od-v2-no-cancel">
          <p className="od-v2-no-cancel-title">{t("CANCELLATION_TIME_PASSED")}</p>
          <div className="od-v2-service-box">
            <p className="od-v2-service-text">
              <Trans i18nKey="NO_CANCEL_CONTACT_WHATSAPP" components={{ phone: <strong className="od-v2-service-phone" /> }} />
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default OrderDetails;
